<mat-toolbar class="navbar navbar-expand-lg" style="height: 45px;position: fixed;right: 0;z-index: 1;" [ngStyle]="{'background-color': isColor}">
    <button *ngIf="isBackButton" mat-icon-button (click)="appService.goBack()" style="background-color: transparent;">
        <mat-icon style="color: #A6B0B9;">arrow_back</mat-icon>
    </button>
    <mat-label *ngIf="isTitle != 'DigimaxOTO'" style="color: #A6B0B9;font-family: Roboto;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 70%;">{{isTitle}} <mat-label style="color: #32B44A;font-family: Roboto;"> {{isTitlePath}}</mat-label></mat-label>
    <span class="spacer"></span>
    <img *ngIf="isLogo" src="../../assets/DigimaxOTO-logo.png" style="height: 30px;" alt="volta">
    <span class="spacer"></span>
</mat-toolbar>